import { render, staticRenderFns } from "./swift_M5.vue?vue&type=template&id=9984c4fe&scoped=true&"
import script from "./swift_M5.vue?vue&type=script&lang=js&"
export * from "./swift_M5.vue?vue&type=script&lang=js&"
import style0 from "./swift_M5.vue?vue&type=style&index=0&id=9984c4fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9984c4fe",
  null
  
)

export default component.exports